import main from '@/view/Main' //메인화면
import intro from '@/view/CompanyIntro' //회사소개
import service from '@/view/Service' //서비스
const paths = [
  {
    path: '/',
    name: 'main',
    component: main,
  },
  {
    path: '/intro',
    name: 'intro',
    component: intro,
  },
  {
    path: '/service',
    name: 'service',
    component: service,
  },
]

export default paths



// WEBPACK FOOTER //
// ./src/router/path.js